export const subjectLimit: Readonly<number> = 100;
export const descriptionLimit: Readonly<number> = 600;
export const commentLimit: Readonly<number> = 600;
export const basicFieldLimit: Readonly<number> = 50;
export const addressFieldLimit: Readonly<number> = 200;
export const webShopServiceName: Readonly<string> = 'WebShop';
export const pageSizeOptions = [10, 25, 50, 100];

export const projectPrefix: Readonly<'SHSDigiCare'> = 'SHSDigiCare';
export const fileNameMaximumLength: Readonly<number> = 256;

/**
 * Placeholder value used when an empty path prefix is needed in URL routes.
 *
 * Some API routes (e.g., `/attachments/:prefix`) require a non-empty path segment.
 * When the actual prefix is empty, this placeholder is sent instead and converted
 * back to an empty string on the backend.
 */
export const EMPTY_PATH_PREFIX: Readonly<string> = '_';
